
























import {Component, Vue} from 'vue-property-decorator';
import Modal from '../elements/modals/Modal.vue';

@Component({components: {Modal}})
export default class HelpModal extends Vue {

  get helpEmail(): string | undefined {
    return process.env.VUE_APP_HELP_EMAIL_ADDRESS!;
  }

  get helpPhoneNumber(): string | undefined {
    return process.env.VUE_APP_HELP_PHONE_NUMBER!;
  }

  get documentUrl(): string | undefined {
    return process.env.VUE_APP_HELP_DOCUMENT_URL!;
  }

  get canDownloadPdf(): boolean {
    return typeof this.documentUrl !== 'undefined' && this.documentUrl.length > 0;
  }

  public open() {
    (this.$refs.modal as Modal).open();
  }
}
